import React from 'react';
import Grid from '../../../Grid';
import styles from './Cards.module.sass';
import { openMetricsExport } from '../../../../utils/exportSchoolFilter';
import useOrderPackageCounts from '../../../../hooks/useOrderPackageCounts';

const SeniorCards = () => {
  const counts = useOrderPackageCounts('/api/v1/orders/order_package_counts_seniors');

  return (
    <div className={styles.cardsContainer}>
      <Grid container>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=ready_for_export&scope=senior_items&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.ready_for_export}
          </a>
          <p className={styles.cardInfo}>
            Items that are ready to be exported
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=not_yet_shipped&scope=senior_items&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.not_yet_shipped}
          </a>
          <p className={styles.cardInfo}>
            Items that have been exported but not shipped
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=shipped_24_hours&scope=senior_items"
             onClick={openMetricsExport}>
            {counts && counts.shipped_24_hours}
          </a>
          <p className={styles.cardInfo}>
            Items that have been shipped in the last 24 hours
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=reprint&scope=senior_items&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.reprint}
          </a>
          <p className={styles.cardInfo}>
            Items marked as reprint
          </p>
        </Grid>
        <Grid container item direction='column' alignItems='center' justify='center' xs={2} classes={styles.gridItem}>
          <a className={styles.count}
             href="/admin/orders/create_zip_for_metrics?package_id=on_hold&scope=senior_items&audited=true"
             onClick={openMetricsExport}>
            {counts && counts.on_hold}
          </a>
          <p className={styles.cardInfo}>
            Items on hold
          </p>
        </Grid>
      </Grid>
    </div>
  );
};

export default SeniorCards
